import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useI18next } from "gatsby-plugin-react-i18next";
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ErrorBox from "../../../../blue-library/components/errorBox";
import Button from "../../../../blue-library/elements/button";
import PopupMsg from "../../../../blue-library/elements/popupMsg";
import useQuotePath from "../../../../blue-library/hooks/useQuotePath";
import { loadTencentCaptcha } from "../../../../shared/utils/tencent_captcha";
import { checkForgotPassword, resendAccountActivation } from "../../../api/login";
var RegisterSentEmail = function RegisterSentEmail(_ref) {
    var location = _ref.location;
    var _useSelector = useSelector(function (state) { return state.site; }), resendEmail = _useSelector.resendEmail;
    var uiState = useSelector(function (state) { return state.ui; });
    var dispatch = useDispatch();
    var _useTranslation = useTranslation(), t = _useTranslation[0];
    var _useI18next = useI18next(), language = _useI18next.language;
    var _useState = useState(""), errorCode = _useState[0], setErrorCode = _useState[1]; // const setOpen = (status: boolean) => {
    //   dispatch({
    //     type: "ui/setDialogOpen",
    //     payload: { status: status },
    //   });
    // };
    var setCurrentDialog = function setCurrentDialog(screen) { dispatch({ type: "ui/setCurrentDialog", payload: screen }); };
    var _useState2 = useState(0), retryCounter = _useState2[0], setRetryCounter = _useState2[1];
    var screen = uiState.dialogLastPage;
    var originalPath = useQuotePath();
    useEffect(function () {
        //   event: "trackEventNoEcommerce",
        //   "eventDetails.category": "account registration",
        //   "eventDetails.action": "completed",
        //   "eventDetails.label": undefined,
        // });
    }, []);
    var loadCaptcha = /*#__PURE__*/ function () { var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { var data; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
        switch (_context.prev = _context.next) {
            case 0:
                _context.next = 2;
                return loadTencentCaptcha(language);
            case 2:
                data = _context.sent;
                if (!(data && Object.keys(data).length !== 0)) {
                    _context.next = 8;
                    break;
                }
                _context.next = 6;
                return resendEmailAction(data.ticket, data.randstr);
            case 6:
                _context.next = 9;
                break;
            case 8: setErrorCode("-612");
            case 9:
            case "end": return _context.stop();
        }
    } }, _callee); })); return function loadCaptcha() { return _ref2.apply(this, arguments); }; }();
    var resendEmailAction = /*#__PURE__*/ function () { var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(ticket, randStr) { var res, _res; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
        switch (_context2.prev = _context2.next) {
            case 0:
                _context2.t0 = screen;
                _context2.next = _context2.t0 === "forgetPassword" ? 3 : _context2.t0 === "createAccount" ? 8 : 13;
                break;
            case 3:
                _context2.next = 5;
                return checkForgotPassword({ email: resendEmail, referUrl: originalPath, ticket: ticket, randStr: randStr });
            case 5:
                res = _context2.sent;
                if (res.errorCode && res.result === false) {
                    setErrorCode(res.errorCode);
                }
                return _context2.abrupt("break", 14);
            case 8:
                _context2.next = 10;
                return resendAccountActivation({ email: resendEmail, referUrl: originalPath, ticket: ticket, randStr: randStr });
            case 10:
                _res = _context2.sent;
                if (_res.errorCode && _res.result === false) {
                    setErrorCode(_res.errorCode);
                }
                return _context2.abrupt("break", 14);
            case 13: return _context2.abrupt("break", 14);
            case 14: setRetryCounter(retryCounter + 1);
            case 15:
            case "end": return _context2.stop();
        }
    } }, _callee2); })); return function resendEmailAction(_x, _x2) { return _ref3.apply(this, arguments); }; }();
    return /*#__PURE__*/ React.createElement(PopupMsg, { name: "promocode", id: "0", alertStyle: "idea", data: "popupMsgData" }, /*#__PURE__*/ React.createElement("div", { className: "flex flex-col items-center space-y-5" }, /*#__PURE__*/ React.createElement("h4", { className: "mb-3" }, t("" + (screen ? screen + ".title" : "thanksForYourReadingEmail"))), /*#__PURE__*/ React.createElement("p", { className: "w-full" }, t("" + (screen ? screen + ".body" : "weHadSendEmailToConfirm"))), /*#__PURE__*/ React.createElement("p", { className: "text-center" }, t("" + (screen ? screen + ".body2" : "needToClickLinkToFinish"))), location === "qnb" ? /*#__PURE__*/ React.createElement(Button, { text: t(screen + ".button"), btnStyle: "outline", onClick: function onClick() { setCurrentDialog("login"); } }) : /*#__PURE__*/ React.createElement(Button, { btnStyle: "outline", size: "lg", text: screen === "forgetPassword" ? t("backToLoginPageForgetPW") : t("backToLoginPage"), onClick: function onClick() { setCurrentDialog("login"); } }), /*#__PURE__*/ React.createElement("div", { className: "w-full items-center flex flex-col space-y-5 pt-5 border-t border-black" }, screen === "forgetPassword" ? /*#__PURE__*/ React.createElement("p", null, t("haveNotRecEmailForgetPW")) : /*#__PURE__*/ React.createElement("p", null, t("haveNotRecEmail")), /*#__PURE__*/ React.createElement(Countdown, { key: retryCounter, date: Date.now() + 60000, renderer: function renderer(props) { return /*#__PURE__*/ React.createElement(Button, { color: "white", text: t("resendEmail") + " " + (props.seconds === 0 ? "" : props.seconds + "s"), disabled: !props.completed, onClick: function onClick() { loadCaptcha(); } }); } }), /*#__PURE__*/ React.createElement(ErrorBox, { errorCode: errorCode }))));
};
export default RegisterSentEmail;
